import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';

// --- 1. IMPORT the static JSON data directly ---
import menuData from '../data/menuDrinks.json'; 

const DrinkDetailScreen = () => {
  const { drinkId } = useParams(); // Get the ID from the URL, e.g., "md01"
  
  // --- 2. FIND the specific drink from the imported data ---
  const drink = menuData.menuDrinks.find(d => d.id === drinkId);

  // Scroll to the top of the page when the component loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // --- 3. RENDER the "Not Found" message if the drink doesn't exist ---
  if (!drink) {
    return (
      <>
        <Navbar />
        <div className="not-found-container">
          <div className="not-found-content">
            <h2>Drink not found</h2>
            <Link to="/menu" className="back-to-menu-link">Back to Menu</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // --- 4. RENDER the drink details if the drink is found ---
  return (
    <>
      <Navbar />
      <div className="drink-detail-page">
        <header className="drink-detail-container" style={{'--theme-color': drink.themeColor || '#333'}}>
          <div className="detail-left-column">
            <div className="detail-text-content">
              <h1>{drink.name}</h1>
              <h2>{drink.tagline}</h2>
              <h3>{drink.subheading}</h3>
              <p>{drink.description}</p>
              <div className="options-container">
                <div className="options-list">
                  <h4>Options:</h4>
                  <ul>{drink.options && drink.options.map((o, i) => <li key={i}>{o}</li>)}</ul>
                </div>
                <div className="options-list">
                  <h4>Supplements:</h4>
                  <ul>{drink.supplements && drink.supplements.map((s, i) => <li key={i}>{s}</li>)}</ul>
                </div>
              </div>
            </div>
          </div>
          <div className="detail-right-column">
            <img src={drink.mainImage} alt={drink.name} className="detail-main-image" />
          </div>
        </header>

        {drink.moreDetails && drink.moreDetails.length > 0 && (
          <main className="drink-details-body">
            <div className="details-body-header">
              <h2 style={{ color: drink.themeColor || '#333' }}>
                The Making of a Perfect {drink.name}
              </h2>
            </div>
            {drink.moreDetails.map((detail, index) => (
              <div key={index} className="detail-item">
                <div className="detail-item-image">
                  <img src={detail.image} alt={`${drink.name} detail ${index + 1}`} />
                </div>
                <div className="detail-item-text">
                  <p>{detail.text}</p>
                </div>
              </div>
            ))}
          </main>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DrinkDetailScreen;